import React from 'react';
import { Layout } from 'antd';
import CONSTANT from '../../constant';
import Subscribe from '../../util/subscribe';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import './header.less';
import './header.editor.web.less';

import MainDropdowns from './main.dropdown';
import Language from './language';
import PanelBtn from './panel.btn';
import BrowserCheck from './browser.check';
import ProjectName from './project.name';
import LocalFile from './localfile';
import Publish from './publish';
import AccountDropdown from './account.dropdown';
import Tutorial from './tutorial';

class HeaderEditorWeb extends React.Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        window.addEventListener('load', () => {
            const updateOnlineStatus = () => {
                const condition = navigator.onLine ? 'online' : 'offline';
                Subscribe.trigger('network', condition);
            };
            window.addEventListener('online', updateOnlineStatus, false);
            window.addEventListener('offline', updateOnlineStatus, false);
        }, false);
    }

    render() {
        const {project} = this.props;
        return (
            <Layout.Header className="header header-web">
                <MainDropdowns />
                <Language />
                <PanelBtn />
                <Tutorial />
                <BrowserCheck />
                <ProjectName />
                <LocalFile />
                <section className='header-cell user-menu-cell'>
                    {
                        project.isForThirdPlatform ? null : <Publish />
                    }

                    <AccountDropdown />
                </section>
                <input id="OpenProjectTarget" type="file" accept={Array.from(CONSTANT.PROJECT_SUFFIX, item => `.${item}`).join(',')} hidden />
            </Layout.Header>
        );
    }
}

const mapStateToProps = state => ({
    project: state.project
});

export default withRouter(connect(
    mapStateToProps
)(HeaderEditorWeb));